import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('OFFICE_HOME_GET_BUSINESS_INFORMATION'),
  ...AsyncRequest.createActionKeys('OFFICE_HOME_SAVE_BUSINESS_INFORMATION'),
  ...AsyncRequest.createActionKeys('OFFICE_HOME_CONFIRM_BACKGROUND_CHECK_INFORMATION'),
  ...AsyncRequest.createActionKeys('OFFICE_HOME_GET_ACCOUNT_OWNER'),
  ...AsyncRequest.createActionKeys('OFFICE_HOME_GET_CHASE_UID'),
  ...AsyncRequest.createActionKeys('OFFICE_HOME_SAVE_TRANSACTION_DETAILS'),
};



// WEBPACK FOOTER //
// ./src/modules/adAgreement/common/office-home-gateway/officeHomeActionKeys.js